<script>
	import { VCard } from "vuetify/lib";

	export default {
		name: "card",

		extends: VCard,
	};
</script>
